import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function RequireAuth({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="max-w-lg mx-auto px-4 py-24 text-center text-gray-600">
        Betöltés…
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/bejelentkezes"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  return children;
}
